export default "/static/images/claim-popup/4.png"